import React from 'react'

import Line from '../../../packages/kiti/components/helpers/Line'
import Modal from '../../structure/Modal'
import ModalPickerFooter from './ModalPickerFooter'
import ModalPickerHeader from './ModalPickerHeader'
import Scroll from '../../../packages/kiti/components/helpers/Scroll'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const ModalPickerWrapper = ({ open, onClose, level, children, onChange, ...props }) => {
  return (
    <Modal width="32rem" noPadding open={open} onClose={onClose} level={level}>
      <ModalPickerHeader disableControl {...props} />
      <Line />

      <Scroll height="65vh">
        {children}
        <Separator weight={12} />
      </Scroll>

      <Line />

      <ModalPickerFooter closeModal={onClose} onChange={onChange || (() => {})} />
    </Modal>
  )
}

export default ModalPickerWrapper
